export default {
  'language.usd': 'ドル',
  'language.eur': 'ユーロ',
  'language.rub': 'ルーブル',
  'language.german': 'Deutsche',
  'language.italian': 'アラビア語',
  'language.arabic': 'Italiano',
  'language.french': 'Français',
  'language.spanish': 'Español',
  'language.russian': 'русский',
  'language.english': 'English',
  'language.iran': 'فارسی',
  'language.japanese': '日本 ',
  'language.yen': '円',
  'language.rial': 'リアル',
  'language.persian': 'ペルシア語',
  'component.select': '選択',
  'form.requierd': '必須',
  'form.isshort': '字数が足りません',
  'form.islong': '字数が多すぎます',
  'form.invalid': '無効',
  'form.number': '数字',
  'alert.info': '注意',
  'alert.warning': '警告',
  'alert.error': 'エラー',
  'alert.notitle': ' ',
  'alert.success': '完了',
  'errorBoundary.oops': 'おっと！！',
  'errorBoundary.weSearched': '目的のページが見つかりませんでした.',
  'errorBoundary.backToHome': 'ホームに戻る',
  'error.receiveerror': '情報受信エラー',
  NextStep: '次',
  Previous: '前',
  FirstName: '名',
  LastName: '姓',
  BirthDate: '生年月日',
  NationalCode: 'ID番号',
  Yes: 'はい',
  No: 'いいえ',
  Jalali: 'イラン暦',
  Miladi: '西暦',
  Hijri: 'イスラム暦',
};
